/**
 * /:ws/inbox/:notificationId — the open notification (any member of its group). The parent route (inbox.tsx) renders
 * the page for both URLs and reads this param, so this route renders nothing of its own.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$ws/inbox/$notificationId')({
  // on a phone the open notification is a full-screen issue view with its comment composer at the bottom, where the
  // create FAB would cover it (the list at /inbox keeps the FAB)
  staticData: { workingSet: true, createFab: false },
  component: () => null,
});
